"use client";

import { CardPost } from "@/components/card-post";
import { MotionFadeIn } from "@/components/motion-fade-in";
import { Post, posts } from "@/data/blog-posts";

function BlogPostsContent() {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {posts
        .slice(-3)
        .reverse()
        ?.map((post: Post, index: number) => (
          <MotionFadeIn direction="bottom" delay={index * 0.1} key={index}>
            <CardPost post={post} />
          </MotionFadeIn>
        ))}
    </div>
  );
}

export default BlogPostsContent;
